import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { addTagToItinerary, deleteTagFromItinerary, fetchItineraryTags } from './api/api-itinerary-tags.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';
import { useAuthQuery } from '#lib/hooks/use-query.js';

export function useItineraryTags(itineraryId) {
    if (!itineraryId) return {}
    const { data, isLoading } = useAuthQuery({
        queryKey: ['itinerary-tags', itineraryId],
        queryFn: (_, authHeaders) => fetchItineraryTags(itineraryId, authHeaders),
        refetchOnWindowFocus: false,
        //staleTime: Infinity,
        //keepPreviousData: true
    });
    const { mutate: addMutation } = useAuthMutation({
        mutationFn: (tag, authHeaders) => addTagToItinerary({ ...tag, itineraryId }, authHeaders),
        onSuccess: (res) => {
            toast.success(_t.global.success());
            const updatedTags = [...tags, res.tag];
            setTags(updatedTags);
        },
        onError: (error) => {
            toast.error(error.message);
        }
    });
    const { mutate: removeMutation } = useAuthMutation({
        mutationFn: (id, authHeaders) => deleteTagFromItinerary({ itineraryId, id }, authHeaders),
        onSuccess: (res) => {
            toast.success(_t.global.success());
            const filteredTags = tags.filter(el => el.id !== res.id)
            setTags(filteredTags);
        },
        onError: (error) => {
            toast.error(error.message);
        }
    });

    const [tags, setTags] = useState(data ?? []);
    useEffect(() => {
        if (data) setTags(data);
    }, [data]);

    const deleteTag = (id) => {
        if (!confirm(_t.global.confirm())) return;
        return removeMutation(id);
    };

    return {
        tags,
        isLoading,
        associateTag: addMutation,
        deleteTag
    };
}
